import { useSelector } from 'react-redux';
import { User } from '@csp/csp-common-model';
import { getUserSelector } from '../ducks/principalContextSelectors';

export const useCurrentUser = (): User => {
  const user = useSelector(getUserSelector);

  if (user) {
    return user;
  } else {
    throw new Error(
      'User object not found in the store. Do not use this hook outside of study specific pages, where the principal (and thus user) is undefined.',
    );
  }
};
